import React from 'react';
import {Pie} from "@ant-design/plots";
import {Spin, Button, Tooltip, Card} from "antd";
import {FileExcelFilled} from "@ant-design/icons";
import * as XLSX from 'xlsx';

const GroupCars = ({data, user, loading}) => {

    const handleDownload = () => {

        const title = 'Ariza_Durum_Raporu';
        const workbook = XLSX.utils.book_new();

        const header = [
            ['Rapor Tipi:', 'Arıza Durum Raporu'],
            ['Rapor Oluşturma Tarihi:', new Date().toLocaleString()],
            ['Raporu Oluşturan:', user?.name || 'Bilinmiyor'],
            [],
        ];

        const summaryHeader = [['Arıza Durumu', 'Araç Sayısı']];
        const summaryBody = data.map(item => [item.type, item.value]);

        const detailsHeader = [['Durum', 'Plaka', 'Kapı Numarası']];
        const detailsBody = data.flatMap(item =>
            item.vehicles.map(vehicle => [
                item.type,
                vehicle.plateNumber,
                vehicle.operationNumber,
            ])
        );

        const worksheetData = [
            ...header,
            ...summaryHeader,
            ...summaryBody,
            [],
            ...detailsHeader,
            ...detailsBody,
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const maxWidths = worksheetData[0].map((_, colIndex) =>
            Math.max(...worksheetData.map(row => (row[colIndex]?.toString().length || 0)))
        );
        worksheet['!cols'] = maxWidths.map(width => ({width}));

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Arıza Durum Raporu');
        XLSX.writeFile(workbook, `${title}.xlsx`);
    };

    const config = {
        appendPadding: 10,
        data: data,
        angleField: 'value',
        colorField: 'type',
        animation: false,
        color: ({type}) => {
            switch (type) {
                case "Arızalı Araçlar":
                    return "#FF0000"; // Kırmızı
                case "Uyarılı Araçlar":
                    return "#FFA500"; // Turuncu
                case "Hatasız Aktif Araçlar":
                    return "#008000"; // Yeşil
                case "Hatasız İnaktif Araçlar":
                    return "#808080"; // Gri
                default:
                    return "#D3D3D3"; // Bilinmeyen için gri
            }
        },
        radius: 0.9,
        label: {
            type: 'inner',
            offset: '-30%',
            content: ({percent}) => `${(percent * 100).toFixed(0)}%`,
            style: {fontSize: 14, textAlign: 'center'},
        },
        interactions: [{type: 'element-active'}],
    };

    return (
        <Card
            type="inner"
            size="small"
            title="Arıza Durumu"
            extra={
                <Tooltip title="Rapor olarak indir">
                    <Button
                        type="text"
                        icon={<FileExcelFilled/>}
                        onClick={handleDownload}
                    />
                </Tooltip>
            }
        >
            <div style={{position: 'relative', height: 355}}>
                {loading ? (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <Spin/>
                    </div>
                ) : (
                    <Pie {...config} style={{height: 355}}/>
                )}
            </div>
        </Card>
    );
};

export default GroupCars;
